<template>
  <slot name="default" v-bind="{ click, isLoading }" />
</template>

<script>
import { isLoading } from '../composables/orderProcess.js'

export default {
  props: {
    clickTo: String
  },
  data() {
    return {
      button: null
    }
  },
  computed: {
    isLoading() {
      return isLoading.value
    }
  },
  methods: {
    click() {
      window.document.querySelector(this.clickTo).click()
    }
  }
}
</script>
